import { Component, OnInit } from '@angular/core';
import { InscripcionesService } from '../Common/inscripciones.service';
import { environment } from 'src/environments/environment';
import { MATERIAL_MODULES } from 'src/app/Common/material.config';

@Component({
    selector: 'app-web-inscripciones-error-tpv',
    templateUrl: './web-inscripciones-error-tpv.component.html',
    styleUrls: [
        '../Common/page.scss',
        './web-inscripciones-error-tpv.component.scss'
    ],
    standalone: true,
    imports: [...MATERIAL_MODULES]
})
export class WebInscripcionesErrorTpvComponent implements OnInit {
  public event_name = environment.event_name;
  public event_year = environment.event_year;

  constructor(private _InscripcionesS: InscripcionesService) { }

  ngOnInit(): void {
      
      this._InscripcionesS.deleteInscripcionPendientes().subscribe();
  
  }

}
